module.exports = __webpack_public_path__ + "img/rec_edges_l_t.893d27d9.png";